import React from 'react';
import CircledIcon from './CircledIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faG, faGear } from '@fortawesome/free-solid-svg-icons';

const Skills = ({ skills, displayFormula }) => {
  const numToString = num => {
    if (num > 10) {
      return 'more than ten';
    }

    return {
      0: 'no',
      1: 'one',
      2: 'two',
      3: 'three',
      4: 'four',
      5: 'five',
      6: 'six',
      7: 'seven',
      8: 'eight',
      9: 'nine',
      10: 'ten',
    }[num];
  };

  return (
    <div className={displayFormula ? 'py-5 px-sm-5' : 'py-5 px-sm-5 bg-light'}>
      <div className="container">
        <div className="d-flex align-items-center justify-content-center">
          <h1 className="font-weight-bold text-center">
            Your Headline's Hard & Soft Skills
          </h1>
        </div>
        <h6 className="text-center mt-2">
          Your LinkedIn headline{' '}
          {skills.length < 3 && skills.length > 0 && 'only'} includes{' '}
          {numToString(skills.length)} hard / soft skill
          {skills.length > 1 && 's'}
          {skills.length > 0 ? ':' : '.'}
        </h6>

        <div className="my-3">
          {skills.map(skill => (
            <h5 className="text-center font-weight-bold">{skill}</h5>
          ))}
        </div>

        <h6 className="text-center">
          Including relevant keywords and skills will help you boost your
          visibility in LinkedIn's search algorithm. We recommend including a
          minimum of 3 hard or soft skills in your headline.
        </h6>

        <div className="pt-4 pb-5 d-flex justify-content-center">
          <div className="my-auto">
            <CircledIcon value={skills.length > 2} />
          </div>
          <h6 className="my-auto ml-3 d-inline-block">
            {skills.length < 3
              ? `Add ${
                  3 - skills.length
                } more hard or soft skills to improve your
            score.`
              : 'Nicely done! You have at least 3 hard or soft skills in your headline.'}
          </h6>
        </div>

        <div className="d-flex justify-content-center">
          <a
            className="btn btn-primary d-flex row align-items-center skill-btn"
            target="_blank"
            rel="noopener noreferrer"
            href="https://youtu.be/MDCUarMnwpM"
          >
            <div className="col-md-1 d-none d-md-block">
              <div className="rounded-circle small-circle bg-primary d-flex align-items-center justify-content-center">
                <FontAwesomeIcon color="white" size="1x" icon={faGear} />
              </div>
            </div>
            <span className="col font-override">
              Not Sure How To Find Skills? Click Here!
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Skills;
